const fallbackCopyTextToClipboard = (container, text) => {
  container = (container) ? container : document.body;

  const textArea = document.createElement(`textarea`);
  textArea.value = text;

  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.position = `fixed`;
  textArea.style.opacity = 0;

  container.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand(`copy`);
  } catch (error) {
    console.error(`Fallback: Unable to copy.`, error);
  }

  container.removeChild(textArea);

};

export const copyTextToClipboard = (container, text) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(container, text);
    return;
  }

  navigator.clipboard.writeText(text)
    .then(
        () => {
          console.log(`Async: Copying to clipboard was successful!`);
        }, (error) => {
          console.error(`Async: Could not copy text: `, error);
        }
    );
};
